var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8197 25.1C17.2892 25.1 18.6978 24.5167 19.737 23.4775C20.7754 22.4384 21.3596 21.0298 21.3596 19.5602L21.3598 8.7848L21.3593 8.7777C21.2583 7.36057 20.4429 6.09156 19.1963 5.4103C17.9489 4.72991 16.4416 4.72995 15.1941 5.41033C13.9475 6.09156 13.1319 7.36047 13.031 8.77768V17.7608C13.031 19.301 14.2795 20.5495 15.8197 20.5495C17.3599 20.5495 18.6085 19.301 18.6085 17.7608V13.2105C18.6085 12.6984 18.1934 12.2832 17.6812 12.2832C17.1691 12.2832 16.7539 12.6984 16.7539 13.2105V17.7608C16.7539 18.2767 16.3357 18.6949 15.8197 18.6949C15.3038 18.6949 14.8856 18.2767 14.8856 17.7608V8.78948C14.9985 7.59811 15.9982 6.68807 17.1947 6.68807C18.3915 6.68807 19.392 7.59818 19.5047 8.78947V19.5602C19.5047 20.8769 18.8023 22.0929 17.6617 22.7514C16.522 23.4098 15.1171 23.4097 13.9774 22.7514C12.8368 22.093 12.1344 20.877 12.1344 19.5602V13.2107C12.1344 12.6986 11.7193 12.2834 11.2071 12.2834C10.695 12.2834 10.2798 12.6986 10.2798 13.2107V19.5602C10.2798 21.0297 10.864 22.4383 11.9023 23.4775C12.9415 24.5167 14.3502 25.1 15.8197 25.1Z",
    fill: "#465ACD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/Attachment.7772f022e2573c406903d5737554304f.svg";
export { ForwardRef as ReactComponent };